var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_900_16170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5C8.42 13.5 5.5 10.58 5.5 7C5.5 3.42 8.42 0.5 12 0.5C15.58 0.5 18.5 3.42 18.5 7C18.5 10.58 15.58 13.5 12 13.5Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4999 24.5H1.49989C0.969886 24.5 0.479886 24.22 0.209886 23.76C-0.0601143 23.3 -0.0701143 22.73 0.189886 22.27C2.51989 18.09 7.03989 15.5 11.9999 15.5C16.9599 15.5 21.4799 18.09 23.8099 22.27C24.0699 22.73 24.0599 23.3 23.7899 23.76C23.5199 24.22 23.0299 24.5 22.4999 24.5Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_900_16170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFilled);
export default __webpack_public_path__ + "static/media/UserFilled.e4fcee38.svg";
export { ForwardRef as ReactComponent };